import React, { forwardRef } from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_SectionContainer__3EWRJ{border-radius:8px;box-shadow:var(--content-box-shadow-80);background-color:var(--graybackground);padding:40px 18px;margin-top:20px;color:var(--white);position:relative;flex-direction:column;display:flex;align-items:center}.styles-module_SectionTitle__3oEYH{top:10px;left:18px;position:absolute;display:flex;flex-direction:row;justify-content:space-between}.styles-module_SectionTitle__3oEYH svg{color:var(--brown-gray);width:20px;height:20px;margin:0 8px}";
var styles = {"SectionContainer":"styles-module_SectionContainer__3EWRJ","SectionTitle":"styles-module_SectionTitle__3oEYH"};
styleInject(css_248z,{"insertAt":"top"});

var SectionContainer = forwardRef(function (_a, ref) {
    var children = _a.children, dataCy = _a.dataCy, title = _a.title, id = _a.id, tooltip = _a.tooltip;
    return (React.createElement("div", { className: styles.SectionContainer, id: id, ref: ref, "data-cy": dataCy },
        title && (React.createElement("div", { className: styles.SectionTitle },
            title,
            tooltip)),
        children));
});

export { SectionContainer };
